/**
 * Revisor de Lista de Ferragens — router-shell (modulo legado).
 *
 * Fluxo:
 *  index                  -> Projetos (seleciona projetos do DinaBox)
 *  /editor                -> Editor (monta a lista; "Salvar" persiste)
 *  /historico             -> Historico (listas salvas)
 *  /historico/:id         -> ListaSalva (reabre snapshot: confere + imprime)
 *
 * Visual 100% design system do ERP. O DinaBox e' acessado via proxy do backend
 * (credencial pessoal cadastrada em Configuracoes > DinaBox).
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { RevisorProvider } from "./context";
import Projetos from "./Projetos";
import Editor from "./Editor";
import Impressao from "./Impressao";
import Historico from "./Historico";
import ListaSalva from "./ListaSalva";

export default function RevisorFerragens() {
  return (
    <RevisorProvider>
      <Routes>
        <Route index element={<Projetos />} />
        <Route path="editor" element={<Editor />} />
        <Route path="imprimir" element={<Impressao />} />
        <Route path="historico" element={<Historico />} />
        <Route path="historico/:id" element={<ListaSalva />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </RevisorProvider>
  );
}
